var _defs, _path, _line, _line2, _line3, _path2, _line4, _line5, _line6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgalimentacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-Servicio",
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 544.54 487.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n.cls-1,.cls-2{fill:none;stroke:red;stroke-linecap:round;stroke-miterlimit:10;}\r\n.cls-1,.cls-2{stroke-width:10px;}\r\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.5,6.62H261a5.13,5.13,0,0,1,5,3.81c6.5,24.46,39.57,159-14.28,175.69a10.56,10.56,0,0,0-7.38,10.52l9.45,231.47a55,55,0,0,1-15.49,41c-10.71,10.84-25.86,17.05-42.72-3.57a55.12,55.12,0,0,1-12.17-37.4l10.22-230.55a9.83,9.83,0,0,0-9.25-10.23c-18.76-1.22-54.68-21.81-14.86-176.86A5.14,5.14,0,0,1,174.5,6.62Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 192.94,
    y1: 6.62,
    x2: 192.94,
    y2: 122.18
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 218.84,
    y1: 6.62,
    x2: 218.84,
    y2: 122.18
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 244.74,
    y1: 6.62,
    x2: 244.74,
    y2: 122.18
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M354.14,6.62V432.93a57,57,0,0,0,5.2,24c7.49,16.19,25,28.5,44.46,16.19,14.05-8.88,17-28.56,15.37-45.1l-14-144.6a12.68,12.68,0,0,1,9.36-13.51c10.69-2.79,25.67-10.1,25.38-29.11-.47-29.51,0-170.61,0-170.61S425,7.93,354.14,6.62Z"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 354.14,
    y1: 270.76,
    x2: 412.13,
    y2: 270.76
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 354.14,
    y1: 311.28,
    x2: 407.85,
    y2: 311.28
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 405.64,
    y1: 288.45,
    x2: 375.24,
    y2: 288.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgalimentacion);
export default __webpack_public_path__ + "static/media/svgalimentacion.224833fe9d6d8b9e3956510185744809.svg";
export { ForwardRef as ReactComponent };